import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
const cn = {
    message: {
        'home': '首页',
    },
    ...zhLocale
}

export default cn